<template>
    <EChart
        card
        :header="$t('finance.yourPayouts')"
        :loading="loading"
        :error="errorMessage"
        height="380"
        type="bar"
        :options="chartOptions"
    >
        <template #nav>
            <p class="text-muted">{{ $t('finance.totalMonthlyPayouts') }}</p>
        </template>
    </EChart>
</template>

<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'FinanceChart',
        components: { EChart },
        props: {
            series: {
                type: Array,
                default: () => [],
            },
            loading: {
                type: Boolean,
                default: false,
            },
            error: {
                type: [Error, Object, String],
                default: null,
            },
            color: {
                type: String,
                default: '#5369f8',
            },
        },
        computed: {
            errorMessage() {
                return this.error?.message || this.error || null;
            },
            chartOptions() {
                return {
                    color: [this.color],
                    xAxis: {
                        type: 'time',
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: val => this.$format.currency(val),
                        },
                    },
                    tooltip: {
                        valueFormatter: val => this.$format.currency(val),
                    },
                    series: [
                        {
                            type: 'bar',
                            data: this.series,
                        },
                    ],
                };
            },
        },
    };
</script>
